<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            :validations="validations.unidade"
                            @change="handleUnidadeChange"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.especialidades"
                            @change="handleEspecialidadeChange"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.statusId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.idadeDe"
                            label="Idade de"
                            number
                            v-model="model.idadeDe"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.idadeAte"
                            label="Idade até"
                            number
                            v-model="model.idadeAte"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="data.itens"
                    hide-pagination
                >
                    <template v-slot:cell(paciente)="{item}">
                        {{item.pacienteNome}} / {{item.pacienteCns ? formatCns(item.pacienteCns) : null}}
                    </template>

                    <template v-slot:custom-foot>
                        <rkm-tr>
                            <rkm-th
                                class="text-right"
                                colspan="6"
                            >
                                Total: {{data.totalizadores.quantidadeAtendimentos}}
                            </rkm-th>
                        </rkm-tr>
                    </template>
                </rkm-table>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                unidade: {required: true},
                idadeDe: {
                    max: 3,
                    min_value: 0,
                    max_value: this.model.idadeAte ? this.model.idadeDe : 999,
                },
                idadeAte: {
                    max: 3,
                    min_value: this.model.idadeDe ? this.model.idadeDe : 0,
                    max_value: 999,
                },
            }
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            relatorioEstatisticoPaciente: this.getConectaSusRepository('ambulatorio.relatorioEstatisticoPaciente'),
        }

        this.load()
    },
    data() {
        return {
            form: null,
            fields: [
                {key: 'data', label: 'Data', sortable: true},
                {key: 'especialidadeNome', label: 'Especialidade', sortable: true},
                {key: 'usuarioNome', label: 'Profissional', sortable: true},
                {key: 'paciente', label: 'Paciente / CNS', sortable: true},
                {key: 'agendamentoStatusNome', label: 'Status', sortable: true},
                {key: 'pacienteIdade', label: 'Idade', sortable: true},
            ],
            data: null,
            model: null,
            others: {moment},
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioEstatisticoPaciente.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                statusId: this.model.statusId,
                idadeDe: this.model.idadeDe,
                idadeAte: this.model.idadeAte,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoPaciente.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.statusId = null
            this.model.idadeDe = null
            this.model.idadeAte = null

            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                statusId: this.model.statusId,
                idadeDe: this.model.idadeDe,
                idadeAte: this.model.idadeAte,
            }

            this.repositories.impressao.relatorioEstatisticoPaciente(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.statusId = null
            this.model.idadeDe = null
            this.model.idadeAte = null
            this.data = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.statusId = null
            this.model.idadeDe = null
            this.model.idadeAte = null
            this.data = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'especialidades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.form.usuarios = []
            this.form.status = []
            this.model.usuarioId = null
            this.model.statusId = null
            this.model.idadeDe = null
            this.model.idadeAte = null
            this.data = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.status = []
            this.model.statusId = null
            this.model.idadeDe = null
            this.model.idadeAte = null
            this.data = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'status',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, formats, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.especialidades = []
                this.form.usuarios = []
                this.form.status = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.especialidadeId = null
                this.model.usuarioId = null
                this.model.statusId = null
                this.model.idadeDe = null
                this.model.idadeAte = null
                this.data = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioEstatisticoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>